module.exports = __webpack_public_path__ + "static/media/SettingsKDS.cd73beef.svg";